import { money } from "@/lib/format";
import PayQRCodes from "@/components/PayQRCodes";

const METHODS = ["Cash App", "Venmo", "Payment link (card/bank)", "Cash", "Other"];

export default function PaymentPlan({ f, set, est, settings }) {
  return (
    <div className="space-y-5">
      <div className="rounded-2xl bg-[#FDF6ED] p-5">
        <p className="label-cap">Your estimated total</p>
        <p data-testid="estimated-total" className="font-heading text-4xl font-bold text-[#2B5338] mt-1">{money(est.total)}{est.tbd && <span className="text-2xl text-stone-600"> + TBD</span>}</p>
        {est.tbd && <p className="text-stone-600 mt-1">Some prices are not set yet.</p>}
      </div>
      {settings.payment_due && <p data-testid="payment-due-text" className="text-lg font-semibold">Activity payments are due in full by {settings.payment_due}.</p>}
      {settings.payment_instructions && <p className="text-lg whitespace-pre-line rounded-xl border-2 border-amber-200 bg-amber-50 p-4">{settings.payment_instructions}</p>}
      <PayQRCodes />
      <div className="grid sm:grid-cols-2 gap-3">
        {[["full", "Pay in full"], ["partial", "Make partial payments"]].map(([v, l]) => (
          <button type="button" key={v} data-testid={`pay-plan-${v}`} onClick={() => set("pay_plan", v)} aria-pressed={f.pay_plan === v}
            className={`min-h-[56px] rounded-2xl border-2 text-lg font-semibold ${f.pay_plan === v ? "border-[#8C3415] bg-[#8C3415] text-white" : "border-[#E6DBCF] bg-white"}`}>{l}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <label className="block"><span className="block text-lg font-semibold mb-2">Amount you plan to pay now ($) (optional)</span>
          <input data-testid="pay-plan-amount-input" className="field" inputMode="decimal" value={f.pay_plan_amount ?? ""} onChange={(e) => set("pay_plan_amount", e.target.value === "" ? null : Number(e.target.value))} /></label>
        <label className="block"><span className="block text-lg font-semibold mb-2">How you'll pay</span>
          <select data-testid="pay-method-select" className="field" value={f.pay_method || ""} onChange={(e) => set("pay_method", e.target.value)}>
            <option value="">Choose a method…</option>{METHODS.map((m) => <option key={m}>{m}</option>)}
          </select></label>
      </div>
    </div>
  );
}
